export enum RcsRoutes {
  root = 'rcs',
  create = 'create',
}
